import { INSTANCE_URL, itemCount } from "Constants";
import { getRequest, postRequest } from "NetworkCall";

import { SESSION_TOTAL_SESSLIST } from "SessionanalyticSesslistAction";
import { SESSION_TOTAL_SESSVIEW } from "SessionanalyticSessviewAction";
import { SESSION_TOTAL_SESSFAVO } from "SessionanalyticSessfavoAction";

export var SESSION_TOSESS_TABLELIST = "SESSION_TOSESS_TABLELIST";
export var SESSION_TOSESS_QNQINSIGHTS = "SESSION_TOSESS_QNQINSIGHTS";
export var SESSION_MOSTSEARKEYS_TABLELIST = "SESSION_MOSTSEARKEYS_TABLELIST";

export var SPEAKER_SESSLIST = "SPEAKER_SESSLIST";
export var SESSION_SESSVIEW = "SESSION_SESSVIEW";
export var SESSION_SESSFAVO = "SESSION_SESSFAVO";

export var SESSION_SELECTED_ITEM = "SESSION_SELECTED_ITEM";
export var SESSION_ITEM_SELECTED = "SESSION_ITEM_SELECTED"; // main
export var EVENT_SESSION_LIST = "EVENT_SESSION_LIST";
export var SESSION_SCANED_LIST = "SESSION_SCANED_LIST";
export var SESSION_RSVP_USER_LIST = "SESSION_RSVP_USER_LIST";

export function onSessionMenuSelected(selectedMenu) {
  return (dispatch) => {
    dispatch({ type: SESSION_ITEM_SELECTED, payload: selectedMenu });
  };
}

export function dispatchAnalyticsData(data) {
  return (dispatch) => {
    //dispatch({type: SESSION_TOTAL_SESSLIST, payload: {count:data}}); count:data.devices.count
    dispatch({ type: SESSION_TOTAL_SESSLIST, payload: { count: data } });
    dispatch({ type: SESSION_TOTAL_SESSVIEW, payload: { count: data } });
    dispatch({ type: SESSION_TOTAL_SESSFAVO, payload: { count: data } });
  };
}

// Top session (session with most user engagement)
const fetchTopSessionTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=topsessionlist&types=schedule&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for Top session Table data (List) Installs..
        dispatch({ type: SESSION_TOSESS_TABLELIST, data: data.resource });
        callback({
          error: 0,
          data: "Analytics Session Top session Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

// Q&A Insights {Most active q&a for top sessions}
const fetchQnaInshtSessTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=sessqnainsights&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response;
        //Prepare data for Q&A Insights Table data (List) Installs..
        dispatch({ type: SESSION_TOSESS_QNQINSIGHTS, data: data.resource });
        callback({
          error: 0,
          data: "Analytics Session Q&A Insights Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

/******  Most search keywords (most search keywords related to Session) ******/

const fetchSessionMostsearkeysTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=mostsearkeyslist`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "mostsearkeyslist",
        types: "search",
        screen: "schedules",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for most search keywords related to session Table data (List) ..
        dispatch({ type: SESSION_MOSTSEARKEYS_TABLELIST, data: data.resource });
        callback({
          error: 0,
          data: "Analytics most search keywords related to session Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

/* FETCH ALL SESSION NAME WITH EVENT ID */
const fetchSessionListWithEventId = (session, callback) => {
  let url = `${INSTANCE_URL}/api/v2/analytics?type=sessionListWithEventId`;
  return (dispatch) => {
    postRequest(
      url,
      {
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;
        //Prepare data for most search keywords related to session Table data (List) ..
        dispatch({
          type: EVENT_SESSION_LIST,
          data: data.session,
          count: data.count,
        });
        callback({
          error: 0,
          data: response,
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

/* FETCH Admin Panel Session Scanning Analytics / Attendence LIST [Paginated] */
const fetchSessionScanningAttendees = (
  session,
  pageCount = 0,
  countPerPage = 0,
  sessionId = "",
  callback
) => {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  var url = `${INSTANCE_URL}/api/v2/analytics?type=sessionScanngPaginatedList`;

  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "sessionScanngPaginatedList",
        eventid: session.eventid,
        limit: itemCount,
        offset: offset,
        sessionId: sessionId,
      },
      session,
      dispatch,
      (response) => {
        if (response.session_scan_list.length === 0) {
          dispatch({
            type: SESSION_SCANED_LIST,
            payload: { data: {}, count: 0 },
          });
        } else {
          dispatch({
            type: SESSION_SCANED_LIST,
            payload: {
              data: response.session_scan_list,
              count: response.count,
            },
          });
        }

        callback({ status: 1 });
      },
      (error) => {}
    );
  };
};

/* Export CSV For Session scanned attendence */
const fetchDownloadSessionScanning = (session, sessionId = "", callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=sessionScanningCsv`;
  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "sessionScanningCsv",
        eventid: session.eventid,
        sessionId: sessionId,
      },
      session,
      dispatch,
      (response) => {
        callback({ error: 0, data: response });
      },
      (error) => {
        callback({ error: 1, data: {} });
      }
    );
  };
};

/* SESSION RSVP LIST [Paginated] */
const fetchSessionRSVPAttendees = (
  session,
  pageCount = 0,
  countPerPage = 0,
  sessionId = "",
  callback
) => {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  var url = `${INSTANCE_URL}/api/v2/analytics?type=sessionRsvpUsersPaginatedList`;

  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "sessionRsvpUsersPaginatedList",
        eventid: session.eventid,
        limit: itemCount,
        offset: offset,
        sessionId: sessionId,
      },
      session,
      dispatch,
      (response) => {
        if (response.session_rsvp_list.length === 0) {
          dispatch({
            type: SESSION_RSVP_USER_LIST,
            payload: { data: {}, count: 0 },
          });
        } else {
          dispatch({
            type: SESSION_RSVP_USER_LIST,
            payload: {
              data: response.session_rsvp_list,
              count: response.count,
            },
          });
        }

        callback({ status: 1 });
      },
      (error) => {}
    );
  };
};

/* Export CSV For Session RSVP attendence */
const fetchDownloadSessionRSVP = (session, sessionId = "", callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=sessionRSVPCsv`;
  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "sessionRSVPCsv",
        eventid: session.eventid,
        sessionId: sessionId,
      },
      session,
      dispatch,
      (response) => {
        callback({ error: 0, data: response });
      },
      (error) => {
        callback({ error: 1, data: {} });
      }
    );
  };
};

export {
  fetchTopSessionTableData,
  fetchQnaInshtSessTableData,
  fetchSessionMostsearkeysTableData,
  fetchSessionListWithEventId,
  fetchSessionScanningAttendees,
  fetchDownloadSessionScanning,
  fetchSessionRSVPAttendees,
  fetchDownloadSessionRSVP,
};
